export const data = [
  {
    year: '2012',
    'ESG-Mandated': 3.7,
    'Non ESG-Mandated': 29.6
  },
  {
    year: '2018',
    'ESG-Mandated': 12,
    'Non ESG-Mandated': 34.6
  },
  {
    year: '2025',
    'ESG-Mandated': 34.5,
    'Non ESG-Mandated': 34.5
  }
];
